import {
  getTenantFeatureFlags,
  listFeatureFlagCatalogue,
  removeTenantFeatureFlag,
  setTenantFeatureFlag,
} from '@t4s/api-client'
import type { FeatureFlagCatalogueEntry, TenantFeatureFlagsFlags } from '@t4s/api-client/model'
import { unwrap } from '../lib/api-error.ts'

/**
 * The four generated calls the feature-flags screen is made of —
 * docs/ux/PLATFORM-ADMIN.md §14, against P04a-api's endpoints.
 *
 * **This task adds no route.** All four already exist, behind the platform realm only
 * (`docs/ux/PLATFORM-ADMIN.md` §14.3, §6.2): the catalogue is platform-wide and carries no
 * tenant id; the other three are one tenant's own resolved map, one key at a time.
 */

export function fetchFeatureFlagCatalogue(): Promise<FeatureFlagCatalogueEntry[]> {
  return unwrap<FeatureFlagCatalogueEntry[]>(listFeatureFlagCatalogue())
}

export function fetchTenantFlags(tenantId: string): Promise<TenantFeatureFlagsFlags> {
  return unwrap<{ flags: TenantFeatureFlagsFlags }>(getTenantFeatureFlags(tenantId)).then(
    (result) => result.flags,
  )
}

export function saveTenantFlag(
  tenantId: string,
  key: string,
  enabled: boolean,
): Promise<TenantFeatureFlagsFlags> {
  return unwrap<{ flags: TenantFeatureFlagsFlags }>(
    setTenantFeatureFlag(tenantId, key, { enabled }),
  ).then((result) => result.flags)
}

export function removeTenantFlag(tenantId: string, key: string): Promise<TenantFeatureFlagsFlags> {
  return unwrap<{ flags: TenantFeatureFlagsFlags }>(removeTenantFeatureFlag(tenantId, key)).then(
    (result) => result.flags,
  )
}

export const CATALOGUE_QUERY_KEY = ['platform', 'feature-flags', 'catalogue'] as const
export const tenantFlagsQueryKey = (tenantId: string) =>
  ['platform', 'tenant', tenantId, 'feature-flags'] as const
